import { queryDataExt } from "../BaseService/index";
const GlobalConfig = new window.globalConfig();

export const getGrowersWithConditions = async (
  whereClause,
  selectFields,
  sortFields
) => {
  return await queryDataExt(
    `${GlobalConfig.REACT_APP_API_GROWER_URL}getWithConditions`,
    whereClause,
    selectFields,
    sortFields
  );
};